import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    users: [],
    selectedUser: "",
    isLoading: false,
    error: null,
    search: "",
    isChangingRole: true,
    isUserSaved: true,
    emailVerified: false,
    userCreationMessage: "",
    currentPage: 1,
    pageSize: 10,
    totalUsers: 0,
    totalPages: 0,
    availablePageSizes: [10, 20, 50]
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        // Loading and Error reducers
        getUsers: (state, action) => {
            state.isLoading = true;
            state.error = null;
            // Update pagination params if provided
            if (action.payload) {
                const { page, pageSize, search } = action.payload;
                if (page !== undefined) state.currentPage = page;
                if (pageSize !== undefined) state.pageSize = pageSize;
                if (search !== undefined) state.search = search;
            }
        },
        addUserStart: (state, action) => {
            state.isUserSaved = true
        },
        addUserSuccessOrFailure: (state, {payload}) => {
            state.isUserSaved = false
        },
        getUserSuccess: (state, {payload}) => {
            state.users = payload.users;
            state.totalUsers = payload.total;
            state.totalPages = Math.ceil(payload.total / state.pageSize);
            state.isLoading = false;
        },
        getUserFailure: (state, {payload}) => {
            state.error = payload;
            state.isLoading = false
        },
        // Pagination reducers
        setCurrentPage: (state, {payload}) => {
            state.currentPage = payload;
        },
        setPageSize: (state, {payload}) => {
            state.pageSize = payload;
            state.currentPage = 1; // Reset to first page when changing page size
        },
        // Clicked User reducers
        setSelectedUser: (state, {payload}) => {
            state.selectedUser = payload;
        },
        setSearch: (state, action) => {
            state.search = action.payload;
            state.currentPage = 1; // Reset to first page when searching
        },
        setSmallSearch: (state, action) => {
            state.smallSearch = action.payload
        },
        deleteUser: (state, action) => {
        },
        changeRole: (state) => {
            state.isChangingRole = false
            console.log("goo1")
        },
        removeAdminRole: (state, action) => {
            state.isChangingRole = false
        },
        setIsChangingRole: (state, action) => {
            state.isChangingRole = true;
        },
        setEmailVerified: (state, action) => {
            state.emailVerified = action.payload
        },
        resUser: (state, {payload}) => {
            state.userCreationMessage = payload
        }
    }
});

export const {
    getUserSuccess,
    getUsers,
    getUserFailure,
    setSearch,
    setSelectedUser,
    deleteUser,
    changeRole,
    removeAdminRole,
    setIsChangingRole,
    addUserStart,
    addUserSuccessOrFailure,
    setEmailVerified,
    resUser,
    setCurrentPage,
    setPageSize
} = userSlice.actions;

export default userSlice.reducer;